import { http } from '@martech-solution/utils/utils';
import { AnnouncementAdd, IAnnouncement } from 'src/types/helpdesk/announcement.type';
import { PagedList } from 'src/types/pagedList.type';

const controller = 'helpdesk/announcements';

export const getAnnouncements = async (searchCondition: string, page: number, pageSize: number, orderBy?: string) =>
  await http.get<PagedList<IAnnouncement>>(controller, {
    params: {
      searchCondition,
      page,
      pageSize,
      orderBy
    }
  });

export const getAnnouncement = async (id: number) => await http.get<IAnnouncement>(`${controller}/${id}`);

export const getAnnouncementByEmployee = async () => await http.get<IAnnouncement[]>(`${controller}/by-employee`);

export const addAnnouncement = async (announcement: AnnouncementAdd) => await http.post(controller, announcement);

export const updateAnnouncement = async (id: number, announcement: AnnouncementAdd) =>
  await http.put(`${controller}/${id}`, announcement);

export const dismissAnnouncement = async (id: number) => await http.post(`${controller}/${id}/dismiss`);

export const deleteAnnouncement = async (id: number) => await http.delete(`${controller}/${id}`);
